import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  getRedirectResult,
  onAuthStateChanged,
  signInWithPopup,
  signInWithRedirect,
  signOut
} from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authBusy, setAuthBusy] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const restoreRedirectLogin = async () => {
      try {
        const result = await getRedirectResult(auth);

        if (!isMounted) return;

        if (result?.user) {
          setUser(result.user);
        }
      } catch (error) {
        console.error('Redirect login error:', error);
      } finally {
        if (!isMounted) return;
        setAuthBusy(false);
      }
    };

    restoreRedirectLogin();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!isMounted) return;
      setUser(currentUser);
      setAuthLoading(false);
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  const loginWithGoogle = async () => {
    if (authBusy) return;

    setAuthBusy(true);

    try {
        await signInWithPopup(auth, googleProvider);
    } catch (error) {
        if (
        error?.code === 'auth/popup-blocked' ||
        error?.code === 'auth/cancelled-popup-request' ||
        error?.code === 'auth/popup-closed-by-user'
        ) {
        try {
            await signInWithRedirect(auth, googleProvider);
            return;
        } catch (redirectError) {
            console.error('Redirect login error:', redirectError);
            alert('Google ile giriş sırasında bir hata oluştu.');
        }
        } else {
        console.error('Google login error:', error);
        alert('Google ile giriş sırasında bir hata oluştu.');
        }
    } finally {
        setAuthBusy(false);
    }
    };

  const logout = async () => {
    if (authBusy) return;

    setAuthBusy(true);

    try {
      await signOut(auth);
    } catch (error) {
      console.error('Logout error:', error);
      alert('Çıkış yapılırken bir hata oluştu.');
    } finally {
      setAuthBusy(false);
    }
  };

  const value = useMemo(() => {
    return {
      user,
      authLoading,
      authBusy,
      loginWithGoogle,
      logout
    };
  }, [user, authLoading, authBusy]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);